import React, { useEffect, useState } from "react";
import ProviderItem from "./ProviderItem";
import Select from "react-select";
import { searchOptions } from "./data";
import PatientList from "./PatientList";

const ProviderList = ({
  providers,
  selectedProvider,
  providerColors,
  handleProvider,
  selectedPatient,
  handlePatient,
  onCLickZoomToMarker,
  patients,
  loading,
}) => {
  const [search, setSearch] = useState("");
  const [searchOption, setSearchOption] = useState(searchOptions[0]);

  const handleSearchOption = (option) => {
    setSearchOption(option);
  };

  useEffect(() => {
    if (selectedProvider == null) {
      setSearch("");
    }
  }, [selectedProvider]);

  return (
    <div className="flex flex-col w-full p-6">
      {providers.map((provider) => (
        <ProviderItem
          key={provider.id}
          provider={provider}
          selectedProvider={selectedProvider}
          providerColors={providerColors}
          handleProvider={handleProvider}
        >
          <div className="flex flex-col w-full gap-2 border-b">
            <input
              type="text"
              placeholder={`Search By ${searchOption.label}...`}
              className="p-2 border rounded-md"
              onChange={(value) => {
                setSearch(value.target.value);
              }}
            />
            <Select
              defaultValue={searchOption}
              name="colors"
              options={searchOptions}
              isDisabled={loading}
              isLoading={loading}
              classNamePrefix="select"
              className="basic-multi-select w-full overflow-visible h-9 z-[1000] mb-3"
              menuPortalTarget={document.body}
              onChange={handleSearchOption}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
            />
          </div>
          <PatientList
            patients={patients.filter((patient) =>
              searchOption === searchOptions[0]
                ? patient.name.toLowerCase().includes(search.toLowerCase())
                : patient.location
                    .toLowerCase()
                    .includes(search.toLowerCase()) ||
                  patient.address.toLowerCase().includes(search.toLowerCase())
            )}
            selectedPatient={selectedPatient}
            handlePatient={handlePatient}
            onCLickZoomToMarker={onCLickZoomToMarker}
          />
        </ProviderItem>
      ))}
    </div>
  );
};

export default ProviderList;
